import { timelineEvents } from "@/mocks/homeMeta";
import SectionHeading from "./SectionHeading";
import { toneChip, toneDot } from "./tones";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          index="05"
          eyebrow="Response Timeline"
          title="回应时间线：把一轮回应按小时排开"
          desc="很多人不是看到假消息，而是看到半截消息。这里补齐从爆料到各方回应的完整顺序，谁先谁后一目了然。"
          actionLabel="导出这一轮时间线"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-24 rounded-lg bg-background-100 border border-background-200 p-6">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-500 kd-pulse-dot" />
                <span className="text-xs font-label tracking-widest text-primary-700">
                  进行中
                </span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950">
                录音剪辑之争 · 第二轮
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                从首条爆料帖到平台方补充公告，共记录 7 个关键节点，其中 3 条为新补上的时间戳。
              </p>
              <div className="mt-5 grid grid-cols-3 gap-3 text-center">
                <div className="rounded-md bg-background-50 border border-background-200 py-3">
                  <div className="font-heading text-lg font-bold text-foreground-950">7</div>
                  <div className="text-[11px] font-label text-foreground-500 mt-0.5">
                    节点
                  </div>
                </div>
                <div className="rounded-md bg-background-50 border border-background-200 py-3">
                  <div className="font-heading text-lg font-bold text-accent-700">5</div>
                  <div className="text-[11px] font-label text-foreground-500 mt-0.5">
                    声明
                  </div>
                </div>
                <div className="rounded-md bg-background-50 border border-background-200 py-3">
                  <div className="font-heading text-lg font-bold text-primary-700">2</div>
                  <div className="text-[11px] font-label text-foreground-500 mt-0.5">
                    反转
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="mt-5 w-full h-11 rounded-md bg-foreground-950 hover:bg-foreground-900 text-background-50 text-sm font-label transition-colors whitespace-nowrap cursor-pointer"
              >
                订阅后续更新
              </button>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-300 pl-6 md:pl-8 space-y-6">
              {timelineEvents.map((item, idx) => (
                <li key={item.time} className="relative">
                  <span
                    className={`absolute -left-[31px] md:-left-[39px] top-1.5 w-3.5 h-3.5 rounded-full border-2 border-background-50 ${
                      toneDot[item.tone]
                    }`}
                  />
                  <div className="rounded-lg bg-background-50 border border-background-200 p-5">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="text-xs font-label text-foreground-500 whitespace-nowrap">
                        {item.time}
                      </span>
                      <span
                        className={`text-[11px] font-label px-2.5 py-1 rounded-full border whitespace-nowrap ${toneChip[item.tone]}`}
                      >
                        {item.type}
                      </span>
                      <span className="ml-auto text-[11px] font-label text-foreground-400">
                        第 {idx + 1} 步
                      </span>
                    </div>
                    <h4 className="mt-3 font-heading text-base font-semibold text-foreground-950">
                      <a href="#timeline" className="hover:text-primary-700 transition-colors">
                        {item.title}
                      </a>
                    </h4>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                      {item.detail}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}